import { type FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';

/**
 * AdminRoute - Route guard for admin-only pages
 *
 * Checks that the user is:
 * 1. Authenticated
 * 2. Has platform_admin role
 *
 * Redirects non-admins to home page.
 */
export const AdminRoute: FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuthStore();

  // Show loading state while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-text-secondary">Loading...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Redirect to home if not platform admin
  if (user?.platform_role !== 'platform_admin') {
    return <Navigate to="/" replace />;
  }

  // User is authenticated and has admin role
  return <>{children}</>;
};
